import { useState } from "react";
import DcConsum from "./BComponent/DcConsum";
import DcPower from "./BComponent/DcPower";
import HourlyAlarm from "./BComponent/HourlyAlarm";
import MainsFail from "./BComponent/MainsFail";
import PGSummary from "./BComponent/PGSummary";
import PowerAvailability from "./BComponent/PowerAvailability";
import PowerSlab from "./BComponent/PowerSlab";
import PowerStatus from "./BComponent/PowerStatus";
import SiteTranding from "./BComponent/SiteTranding";

export default function BusinessDashboard() {
    const alarmList = [
        { name: 'Mains Fail', id: 1,color:'#5470C6' },
        { name: 'DC Low', id: 2,color: '#91CC75'  },
        { name: 'Site Down', id: 26,color:'#FAC858' },
        { name: 'Door Open', id: 12,color: '#EE6666' },
        { name: 'PG Run', id: 9 ,color: '#73C0DE'},
        { name: 'Device Offline', id: 32,color: '#3BA272' },
        { name: 'Overload', id: 25 ,color: '#FC8452' },
        { name: 'Rectifier Fault', id: 3,color: '#6836f0ff'  },
        { name: 'Smoke', id: 6,color: '#771972ff'  },
        { name: 'ODC Temperature High', id: 15,color: '#4ac72bff'  },
        { name: 'MDB Fault', id: 27,color: '#c25591ff'  },
        // ...add up to 20
    ];
    const [visibleCount, setVisibleCount] = useState(1);
    return (
        <>
            <div className="row mb-2">
                <div className="col-12 mt-2 d-flex justify-content-between align-items-center">
                    <div className="page-title-box">
                        <h4 className="page-title"></h4>
                    </div>
                    <div>

                    </div>
                </div>
            </div>
            <div className="row me-1 ms-1">
                <div className="col-6">
                    <PowerStatus />
                </div>

                <div className="col-6">
                    <DcConsum />
                </div>

                <div className="col-12">
                    <PowerAvailability />
                </div>
                <div className="col-6">
                    <PowerSlab />
                </div>
                <div className="col-6">
                    <DcPower title={`Site Tending`} />
                </div>
                <div className="col-6">
                    <HourlyAlarm title={`Hourly Alarm Report`} id={1} />
                </div>
                {alarmList.slice(0, visibleCount).map(alarm => (
                    <div className="col-6" key={alarm.id}>
                        <MainsFail title={alarm.name} id={alarm.id} bar_color={alarm.color} />
                    </div>
                ))}

            </div>
            {visibleCount < alarmList.length && (
                <div className="row">
                    <div className="col-md-12 text-center">
                        <button
                            className="btn btn-primary"
                            onClick={() => setVisibleCount(prev => prev + 1)}
                        >
                            Load More Alarms
                        </button>
                    </div>
                </div>
            )}

        </>
    )
}